(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-faq-template"]) return;
  try {
    
(function() {
  $('body').on('click', '.shopify_explorer_faq__question', function() {
    $(this).next('.shopify_explorer_faq__answer').slideToggle(400).toggleClass('active');
    $(this).toggleClass('active');
  });

  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideDown(400);
  });

  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideUp(400);
  });

  //show more/show less
  $('.shopify_explorer__content .btn-show-more').click(function () {
    $('.shopify_explorer__content .btn-show-less').css("display", "block");     
    $('.shopify_explorer__content .btn-show-more').hide();
    $('.shopify_explorer__content .shopify_explorer_faq__item:nth-child(n+5)').css("display", "block");
  })
  
  $('.shopify_explorer__content .btn-show-less').click(function () {
      $('.shopify_explorer__content .btn-show-more').show();
      $('.shopify_explorer__content .btn-show-less').hide();     
      $('.shopify_explorer__content .shopify_explorer_faq__item:nth-child(n+5)').css("display", "none");
  })
}());

  } catch(e) { console.error(e); }
})();
})();
